import axios from 'axios';

export async function downloadFile(downloadLink: string, fileName: string) {
	const fileResponse = await fetch(downloadLink);
	const blob = await fileResponse.blob();
	const url = window.URL.createObjectURL(blob);

	const a = document.createElement('a');
	a.href = url;
	a.download = fileName;
	document.body.appendChild(a);
	a.click();

	a.remove();
	window.URL.revokeObjectURL(url);
}
